<template lang="pug">
.features.sr-info.gs.features-home
  .columns.column-reverse-mobile
    .column.column.is-one-quarter.hide-mobile
      .left-sticky
        .column
          .feature-helvetica.top-feature
            span  Our 
            span.w400 Guided Setup
            span  is a tool for using well known third party mining apps with our platform.

        .column
          road-map(
            :step="step"
            :mode="mode"
            :miningType="miningType"
            :algorithm="algorithm"
            :coin="coin"
            :address="address"
            :region="region"
            :port="port"
            :worker="worker"
            :referralCode="referralCode"
            @jumpToStep="jumpToStep"
          )
        
        //- .column
          .feature-helvetica.bottom-feature
            span You can also try our 
            router-link.info-link(to="/miner") 
              span easy mining app
              i.fa.fa-external-link.ml-5

    .column.is-three-quarter#step
      div(v-if="step === 0")
        step-mode(
          @selected="selectMode"
        )

      div(v-if="step === 1")
        step-mining-type(
          @prev="prev"
          @selected="selectMiningType"
        )
      div(v-if="step === 2")
        step-algorithm(
          @prev="prev"
          @selected="selectAlgorithm"
          :miningType="miningType"
        )
      div(v-if="step === 3")
        step-coin(
          @prev="prev"
          @selected="selectCoin"
        )
      div(v-if="step === 4")
        step-address(
          @prev="prev"
          @selected="selectAddress"
          :coin="coin"
        )
      div(v-if="step === 5")
        step-region(
          @prev="prev"
          :mode="mode"
          :algorithm="algorithm"
          @selected="selectRegion"
        )
      div(v-if="step === 6")
        step-port(
          @prev="prev"
          :mode="mode"
          :region="region"
          @selected="selectPort"
        )
      div(v-if="step === 7")
        step-worker(
          @prev="prev"
          :mode="mode"
          @selected="selectWorker"
        )
      div(v-if="step === 8")
        step-referral(
          @prev="prev"
          :mode="mode"
          @selected="selectReferral"
        )
      div(v-if="step === 9")
        step-final(
          @prev="prev"
          :mode="mode"
          :miningType="miningType"
          :algorithm="algorithm"
          :coin="coin"
          :address="address"
          :region="region"
          :port="port"
          :worker="worker"
          :referralCode="referralCode"
        )

</template>

<script>
import StepMode from '../components/get_started/c_step_mode'
import StepMiningType from '../components/get_started/c_step_mining_type'
import StepAlgorithm from '../components/get_started/c_step_algorithm'
import StepCoin from '../components/get_started/c_step_coin'
import StepAddress from '../components/get_started/c_step_address'
import StepRegion from '../components/get_started/c_step_region'
import StepPort from '../components/get_started/c_step_port'
import StepWorker from '../components/get_started/c_step_worker'
import StepReferral from '../components/get_started/c_step_referral'
import StepFinal from '../components/get_started/c_step_final'
import RoadMap from '../components/get_started/c_road_map'
export default {
  name: 'view_get_started',
  data () {
    return {
      step          : 0,
      userStep      : 0,
      totalSteps    : 9,
      mode          : '',
      miningType    : '',
      algorithm     : {},
      algorithmAuto : false,
      coin          : {},
      address       : '',
      region        : {},
      port          : {},
      worker        : '',
      referralCode  : ''
    }
  },
  components : {
    StepMode,
    StepMiningType,
    StepAlgorithm,
    StepCoin,
    StepAddress,
    StepRegion,
    StepPort,
    StepWorker,
    StepReferral,
    StepFinal,
    RoadMap
  },
  created () {
    let vm = this
    vm.updateMetaTags()
    vm.$store.dispatch('setPageSelected', 'getStarted')
    vm.$store.dispatch('validateVersion')
  },
  methods : {
    updateMetaTags () {
      let title = 'unMineable Guided Setup - Earn your favorite crypto coins!'
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    },
    selectMode (code) {
      let vm = this
      vm.mode = code
      if (vm.mode === 'basic') {
        vm.totalSteps = 6
      } else {
        vm.totalSteps = 9
      }
      vm.next()
    },
    selectMiningType (code) {
      let vm = this
      vm.miningType = code

      if (vm.mode === 'basic') {
        vm.totalSteps = 6
        vm.userStep   = 1
        vm.step       = 1
      } else {
        vm.totalSteps = 9
        vm.userStep   = 1
        vm.step       = 1
      }

      vm.next()
    },
    selectAlgorithm (algo, auto) {
      let vm = this
      vm.algorithm     = algo
      vm.algorithmAuto = auto

      if (auto) {
        if (vm.mode === 'basic') {
          vm.totalSteps = 5
          vm.userStep   = 1
          vm.step       = 2
        } else {
          vm.totalSteps = 8
          vm.userStep   = 1
          vm.step       = 2
        }
      } else {
        if (vm.mode === 'basic') {
          vm.totalSteps = 6
          vm.userStep   = 2
          vm.step       = 2
        } else {
          vm.totalSteps = 9
          vm.userStep   = 2
          vm.step       = 2
        }
      }

      vm.next()
    },
    selectCoin (coin) {
      let vm = this
      vm.coin = coin
      vm.next()
    },
    selectAddress (address) {
      let vm = this
      vm.address = address
      vm.next()
    },
    selectRegion (region) {
      let vm = this
      vm.region = region
      if (vm.mode === 'basic') {
        vm.userStep--
      }

      vm.next()
    },
    selectPort (port) {
      let vm = this
      vm.port = port

      if (vm.mode === 'basic') {
        vm.userStep--
      }

      vm.next()
    },
    selectWorker (worker) {
      let vm = this
      vm.worker = worker

      if (vm.mode === 'basic') {
        vm.userStep--
      }

      vm.next()
    },
    selectReferral (referralCode) {
      let vm = this
      vm.referralCode = referralCode
      vm.next()
    },
    jumpToStep (step) {
      let vm = this
      if (vm.step > step) {
        vm.step = step
      }
    },
    next () {
      let vm = this
      vm.userStep++
      vm.step++
    },
    prev () {
      let vm = this
      if (vm.step === 3 && vm.algorithmAuto) {
        vm.step     = 1
        vm.userStep = 1
      } else if (vm.step === 8 && vm.mode === 'basic') {
        vm.step = 4
        vm.userStep--
      } else {
        vm.step--
        vm.userStep--
      }
    }
  }
}
</script>

<style lang="stylus">
.top-feature
  font-size 17px
  text-align left

.gs
  margin: auto;
  position relative
  width 100%
  
  .gs-info
    max-width 720px
    margin: 0px auto;
    margin-bottom 30px
  
  .step-title
    font-size: 27px;
    font-weight: 800;
    margin-bottom 15px
    margin-top 30px
    text-align left
    
  .step-explanation
    font-size 15px
    text-align: justify;
    margin-bottom 30px
  
  .box-container
    margin-top 10px
    display flex
    justify-content center
    align-items center
    .element-box-container
      width 100%
      border-radius 5px
      border 1px solid #ccc
      padding 25px 15px 15px 15px
      margin 10px
      cursor pointer
      text-align center
      &:hover
        border solid 1px #8e8e8e
    
    .box-explanation
      font-size 14px
      text-align: justify;
    
    .tag
      display none
    .is-best
      position relative 
      border 5px solid #b6ffb6
      &:hover
        box-shadow 0 0 20px -10px
      .tag
        border-radius 0px
        background-color #b6ffb6
        font-weight bold
        display inline-block
        position absolute
        top 0px
        left -3px
        padding-top 2px
    
    .element-box-container.text-only
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding 15px !important
      .name
        text-align center
        font-weight 400
        font-size 20px
  
.notif-danger {
  background: #feecf0;
  padding: 10px 15px 10px 15px;
  margin-top: 7px;
  color: #cc0f35
}
.notif-info {
  background: #eff5fb;
  padding: 10px 15px 10px 15px;
  margin-top: 7px;
  color: #296fa8
}
.notif-warning {
  background: #eff5fb;
  padding: 10px 15px 10px 15px;
  margin-top: 7px;
  color: #296fa8
}
.notif-grey {
  background: #f5f4f3;
  padding: 10px 15px 10px 15px;
  margin-top: 7px;
}

.navigation
  display block
  text-align left
  margin-bottom 20px
  

.ml-4
  margin-left 4px

.left-sticky
  position sticky
  top 100px

.articles
  margin 10px 0px
  .article-mini
    cursor pointer
    color #4a4a4a
    padding 5px 0px
    width 100%
    display block
    .article-inner
      border-radius 5px
      border 1px solid #ccc
      padding: 7px 10px 5px 10px;
      display flex
      align-items center
      &:hover
        border solid 1px #8e8e8e
    .article-title
      flex 1
      text-align left
      span
        font-weight 400
    .article-content
      font-size: 12px;
      text-align: justify;
    .article-bottom
      font-size 13px

@media (max-width: 768px)
  .column-reverse-mobile
    display flex
    flex-direction: column-reverse;

html.dark, body.dark
  .step-title
    color #fff
  .box-container
    color #fff
  .navigation
    .button
      background: #2c2c2c;
      color: #fff;
      border solid 1px #fff
      &:hover
        color: #fff;
        border solid 1px #8e8e8e
  .miner
    .title-container
      div
        color #fff
      h1
        color #fff
      a
        color #fff
    .subtitle
      color #fff
  .articles
    a, span
      color: #fff;
    .article-mini
      .article-inner
        &:hover
          border solid 1px #fff

@media (max-width: 768px)
  .hide-mobile
      display none      
        
    


  
</style>



// WEBPACK FOOTER //
// View_Wizard.vue?b44f5bfe